import React, { useEffect, useState } from 'react';
import { EpkExperience } from '../components/website/EpkExperience';
import { DraftBanner } from '../components/website/DraftBanner';
import { getDraftWebsiteContent, getPublishedWebsiteContent, getRequestedStage, websiteDraftStorageKey, websiteDraftUpdatedEvent, websiteStorageKey, websiteUpdatedEvent, type WebsiteContent } from '../data/website';
import { useWebsiteSeo } from '../hooks/useWebsiteSeo';

/**
 * The press kit at /epk. Kept out of search results and out of the public
 * navigation — it is shared directly with bookers, promoters, and press.
 */
export function EpkPage() {
  const isDraft = getRequestedStage() === 'draft';
  const read = () => isDraft ? getDraftWebsiteContent() : getPublishedWebsiteContent();
  const [content, setContent] = useState<WebsiteContent>(read);
  useWebsiteSeo(content, {
    noIndex: true,
    title: `${content.bandName} · Press Kit`,
    description: `Electronic press kit for ${content.bandName} — biography, press photos, music, live history, and booking contact.`,
    shareImageUrl: content.epkHeroImageUrl || content.heroImageUrl,
    canonicalPath: '/epk'
  });
  useEffect(() => {
    const refresh = () => setContent(read());
    const sync = (event: Event) => setContent((event as CustomEvent<WebsiteContent>).detail ?? read());
    const watchedKey = isDraft ? websiteDraftStorageKey : websiteStorageKey;
    const watchedEvent = isDraft ? websiteDraftUpdatedEvent : websiteUpdatedEvent;
    const syncStorage = (event: StorageEvent) => {
      if (event.key === watchedKey) refresh();
    };
    window.addEventListener(watchedEvent, sync);
    window.addEventListener('storage', syncStorage);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener(watchedEvent, sync);
      window.removeEventListener('storage', syncStorage);
      window.removeEventListener('focus', refresh);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDraft]);
  return <>
      {isDraft && <DraftBanner data-id="element-1482" data-mp="3epy98xlo49ed" />}
      <EpkExperience content={content} data-id="element-1483" data-mp="3jmydr42vd43d" />
    </>;
}